import type { OrderStatus } from '../enums/OrderStatus'

export class OrderStatusLogEntity {
  status?: OrderStatus
  createdAt?: string
}
